import * as React from "react";
import "./bootstrap.min.css";
import "./index.css";
import { Provider } from "react-redux";
import App from "./App";
import FrameGate from "./FrameGate";
import { store } from "./store";
import { createRoot } from "react-dom/client";
import { HashRouter as BrowserRouter } from "react-router-dom";
import "./i18n";

const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <FrameGate>
        <App />
      </FrameGate>
    </BrowserRouter>
  </Provider>,
);
